import { Component, Injector, Input } from '@angular/core';
import { BaseControlValueAccessor } from '../../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'jhi-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckBoxComponent,
    multi: true
  }]
})
export class CheckBoxComponent extends BaseControlValueAccessor {

  @Input()
  disabled: boolean;

  value: boolean;

  constructor(injector: Injector) {
    super(injector);
   }

  modelValueChanged(value: any): void {
    this.value = value;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/checkbox/checkbox.component.ts